import { z } from '@tasama/utils';

const COURIER_COMPANY_REGEX = /^[A-Za-z0-9؀-ۿ &'.,()/-]*$/;
const TRACKING_NUMBER_REGEX = /^[A-Za-z0-9\s-]*$/;

export const getDocumentAttestationSchema = (t: (_key: string) => string) => {
  const ns = 'documentAttestation.validation';
  return z.object({
    courierCompany: z
      .string()
      .trim()
      .min(1, t(`${ns}.courierCompany.required`))
      .max(200, t(`${ns}.courierCompany.max`))
      .regex(COURIER_COMPANY_REGEX, t(`${ns}.courierCompany.charset`)),

    trackingNumber: z
      .string()
      .trim()
      .min(1, t(`${ns}.trackingNumber.required`))
      .max(100, t(`${ns}.trackingNumber.max`))
      .regex(TRACKING_NUMBER_REGEX, t(`${ns}.trackingNumber.charset`)),
  });
};

export const documentAttestationSchema = getDocumentAttestationSchema(
  (key) => key
);

export type DocumentAttestationFormValues = z.infer<
  typeof documentAttestationSchema
>;

export type DocumentAttestationFieldName = keyof DocumentAttestationFormValues;

export const documentAttestationDefaultValues: Partial<DocumentAttestationFormValues> =
  {
    courierCompany: '',
    trackingNumber: '',
  };

export const getDocumentAttestationFieldRequirements = () => {
  return {
    courierCompany: { required: true },
    trackingNumber: { required: true },
  };
};
